export default __webpack_public_path__ + "static/media/constructive-feedback.16732f02.svg";